import { render, staticRenderFns } from "./addOrder.vue?vue&type=template&id=2160377c"
import script from "./addOrder.vue?vue&type=script&lang=js"
export * from "./addOrder.vue?vue&type=script&lang=js"
import style0 from "./addOrder.vue?vue&type=style&index=0&id=2160377c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports